export const stats = [
  { value: '36', label: 'Practical lessons' },
  { value: '6', label: 'Digital volumes' },
  { value: '5', label: 'Included bonuses' },
  { value: 'PDF', label: 'Printable materials' },
]

export const differenceStats = [
  { value: '36', label: 'Practical Restaurant Lessons' },
  { value: '1 year', label: 'One Lesson Per Week · 36 Weeks' },
  { value: '45 min', label: 'Suggested Lesson Rhythm' },
]

export const beforeItems = [
  'Hours writing restaurant dialogues from scratch',
  'General textbooks with few real service situations',
  'Role-plays you have to invent the night before',
  'No answer key to check learner work quickly',
  'Menus, orders and bills taught as separate fragments',
]

export const afterItems = [
  'A model dialogue and teacher route for every lesson',
  'Learner worksheets ready to print and hand out',
  'Two paired STAFF/GUEST role cards per lesson',
  'A practical task to close each lesson',
  'Exact teacher keys for quick, confident checking',
]

export const recognizeItems = [
  {
    emoji: '🍽️',
    text: 'Teaching restaurant English without realistic menu and ordering practice',
  },
  {
    emoji: '⏱️',
    text: 'Spending your evening adapting general English to restaurant service',
  },
  {
    emoji: '🎭',
    text: 'Struggling to find role-plays that sound like real staff and guests',
  },
  {
    emoji: '📋',
    text: 'No answer keys to check worksheets on bills, requests or reservations',
  },
  {
    emoji: '☕',
    text: 'Café, counter and takeaway situations missing from your materials',
  },
  { emoji: '🌙', text: 'Still putting tomorrow’s lesson together the night before' },
]

export const packItems = [
  {
    emoji: '🗣️',
    title: 'Model Dialogue & Teacher Route',
    text: 'A clear model conversation and a step-by-step route for leading the lesson',
  },
  {
    emoji: '✏️',
    title: 'Learner Worksheet',
    text: 'Printable practice on the key language of each restaurant situation',
  },
  {
    emoji: '🎭',
    title: 'Two STAFF/GUEST Role-Card Pairs',
    text: 'Paired cards so learners practise both sides of the service conversation',
  },
  {
    emoji: '🧾',
    title: 'Practical Task',
    text: 'A closing task that puts the lesson language to use in a service situation',
  },
  {
    emoji: '🔑',
    title: 'Exact Teacher Key',
    text: 'Answers for every worksheet item so checking is quick and consistent',
  },
  {
    emoji: '🖨️',
    title: 'Printable PDFs',
    text: 'English PDF materials organised by volume and lesson, ready to print',
  },
]

export const samplePages = [
  {
    level: 'Model',
    image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832158674_volume-02-preview-16.webp',
    alt: 'Actual Volume 02 PDF, page 16: Take and Confirm an Order — dialogue and teacher route',
    caption: 'Volume 02 · Model & Teacher Route',
    title: 'Model Dialogue & Teacher Route',
    text: 'A model ordering conversation with a step-by-step route for leading the lesson.',
  },
  {
    level: 'Worksheet',
    image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832160343_volume-02-preview-17.webp',
    alt: 'Actual Volume 02 PDF, page 17: Learner worksheet',
    caption: 'Volume 02 · Learner Worksheet',
    title: 'Learner Worksheet',
    text: 'Printable practice on menu language and taking orders.',
  },
  {
    level: 'Roles',
    image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832161540_volume-02-preview-18.webp',
    alt: 'Actual Volume 02 PDF, page 18: Cut-out staff and guest role cards',
    caption: 'Volume 02 · Role Cards',
    title: 'STAFF/GUEST Role-Card Pairs',
    text: 'Two paired role cards so learners practise both sides of the order.',
  },
  {
    level: 'Task',
    image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832162771_volume-02-preview-19.webp',
    alt: 'Actual Volume 02 PDF, page 19: Order ticket practical task',
    caption: 'Volume 02 · Practical Task',
    title: 'Practical Task',
    text: 'A closing task that brings the lesson language together.',
  },
  {
    level: 'Key',
    image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832164737_volume-02-preview-20.webp',
    alt: 'Actual Volume 02 PDF, page 20: Teacher answer key and feedback',
    caption: 'Volume 02 · Teacher Key',
    title: 'Exact Teacher Key',
    text: 'Answers for every worksheet item in the lesson.',
  },
]

export const volumes = [
  { number: '01', title: 'Welcome, Reservations & Seating' },
  { number: '02', title: 'Menus & Taking Orders' },
  { number: '03', title: 'Café, Counter & Takeaway' },
  { number: '04', title: 'Requests, Problems & Service Recovery' },
  { number: '05', title: 'Bills, Payments & Farewells' },
  { number: '06', title: 'Complete Service Simulations & Assessment' },
]

export const bonuses = [
  { title: '5-Minute Restaurant Warm-Up Bank', image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832227468_bonus-01-mockup.webp' },
  { title: 'Restaurant Pronunciation Clarity Cards', image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832228375_bonus-02-mockup.webp' },
  { title: 'Build-a-Dialogue Restaurant Cards', image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832229152_bonus-03-mockup.webp' },
  { title: 'Mixed-Level Lesson Adaptation Toolkit', image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832230228_bonus-04-mockup.webp' },
  { title: 'Restaurant Role-Play Twist Cards', image: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c7184854-5cc2-4d83-94bc-43fcfb470d93/1791832231679_bonus-05-mockup.webp' },
]

export const offerRows = [
  { label: '6 digital volumes · 36 lessons', value: 'Included' },
  { label: '5 bonuses', value: 'Included' },
  { label: 'Teacher keys & role cards', value: 'Included' },
  { label: 'Printable English PDFs', value: 'Included' },
]

export const optionalExtras = [
  { title: 'Restaurant Job Interview English Kit', price: '$9' },
  { title: 'Restaurant Phone & Message English Kit', price: '$9' },
  { title: 'Events & Catering English Kit', price: '$12' },
]

export const useCases = [
  {
    label: 'Adult ESL',
    title: 'Adult ESL classes',
    text: 'Bring everyday restaurant situations into general English courses for adults comfortable with basic questions and answers.',
  },
  {
    label: 'Vocational',
    title: 'Vocational & hospitality programmes',
    text: 'Add structured service-English practice to culinary, hospitality or food-service training courses.',
  },
  {
    label: 'Staff practice',
    title: 'Staff language practice',
    text: 'Run short, focused sessions with restaurant teams using paired STAFF/GUEST role cards.',
  },
  {
    label: 'Private tutoring',
    title: 'Private tutoring',
    text: 'Work one-to-one through a volume, taking either role and adapting the suggested 45-minute rhythm.',
  },
]

export const faqs = [
  {
    q: 'How does one year of classes in five minutes work?',
    a: 'The kit contains 36 lessons: one per week for a 36-week teaching year. Five minutes refers to reviewing a ready-made lesson, its teacher route and answer key before teaching—not completing a year of learning. Printing and adapting activities to your group may take additional time.',
  },
  {
    q: 'What format are the materials in?',
    a: 'Everything is delivered as English PDF files, organised by volume and lesson, so you can print them or use them on screen.',
  },
  {
    q: 'Who is this kit for?',
    a: 'English teachers, vocational instructors and restaurant trainers working with adults who are already comfortable with basic questions and answers. It is designed for approximate A2–B1 practice and does not provide certification.',
  },
  {
    q: 'Which bonuses are included?',
    a: 'Five bonuses are included in the $27 price: 5-Minute Restaurant Warm-Up Bank, Restaurant Pronunciation Clarity Cards, Build-a-Dialogue Restaurant Cards, Mixed-Level Lesson Adaptation Toolkit and Restaurant Role-Play Twist Cards.',
  },
  {
    q: 'Are there optional extras?',
    a: 'Yes. At checkout you can choose to add the Restaurant Job Interview English Kit ($9), the Restaurant Phone & Message English Kit ($9) or the Events & Catering English Kit ($12). They are optional, paid separately and not part of the $27 kit.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'Yes. The kit is a one-time payment of $27 USD with no subscription. Your bank may apply its own currency conversion.',
  },
  {
    q: 'Do I need audio files?',
    a: 'No. The lessons are built around model dialogues, worksheets, role cards and tasks that you lead in class — no audio is required.',
  },
  {
    q: 'Is this food safety or job training?',
    a: 'No. These are English language-practice materials for restaurant situations. They are not food safety training, a certification or a guarantee of employment or fluency.',
  },
]
